import React, { PropTypes } from 'react';
import CpdLiveItem from 'components/CpdLocker/CpdLiveItem'
import { connect } from 'react-redux';
import actions from 'actions';
import constants from 'constants';
import moment from 'moment';
import storage from 'services/storage.js' 

const {
  LIVE_WEBINARS
} = constants;

const {
  loadUsersWebinarsSaga,
  cleanUsersWebinars
} = actions;


class CpdLive extends React.Component {
  constructor(props) {
    super(props),
    this.state = {
      page: 1
    }
  }

  componentWillMount() {
    this.props.loadWebinars(this.state.page);
  }

  nextPage = () => {
    this.setState({
      page: (this.state.page + 1)
    },
      () => {
        this.props.loadWebinars(this.state.page);
      }
    )
  }

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  render() {
    const token = storage.getSessionData().session.token;
    const {
      int_cpds,
      ext_cpds,
      from,
      to,
    } = (this.props.cpds || {});
    return (
      <div id="live" className="main_live col s12">
        <p className="live_total">
          {from && to && `CPD Year: ${moment(from).format('MMMM YY')} – ${moment(to).format('MMMM YY')}` }
          <br />
          <span>
            { `Ext CPD Points Total: ${ext_cpds} ` }
          </span>
          <br />
          <span>
            { `Int CPD Points Total: ${int_cpds}` }
          </span>
        </p>
        <div className="container_recorded">
          {this.props.webinars.map((webinar) => <CpdLiveItem
            webinar={webinar}
            token={token}
          />)}
        </div>
        {this.props.pages > this.state.page &&
          <a className="more_item" href="javascript:void(0)" onClick={this.nextPage}>LOAD MORE</a>}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  webinars: state.webinars.usersWebinars[LIVE_WEBINARS].values,
  pages: state.webinars.usersWebinars[LIVE_WEBINARS].pages,
  cpds: state.webinars.usersWebinars[LIVE_WEBINARS].cpds
});
const mapDispatchToProps = (dispatch) => ({
  loadWebinars: (page) => dispatch(loadUsersWebinarsSaga(LIVE_WEBINARS, page)),
  cleanWebinars: () => dispatch(cleanUsersWebinars())
});

export default connect(mapStateToProps, mapDispatchToProps)(CpdLive);



/** WEBPACK FOOTER **
 ** ./src/containers/CpdLocker/CpdLive.js
 **/